<template>
    <div class="direitos">
        <div v-if="traduzir == true" class="texto">
            <p>© 2026 Souzo Soluções Digitais. Todos os direitos reservados.</p>

            <router-link to="/politica-de-privacidade">Política de Privacidade</router-link>
        </div>
        <div v-else class="texto">
            <p>© 2026 Souzo Digital Solutions. All rights reserved.</p>

            <router-link to="/politica-de-privacidade">Privacy Policy</router-link>
        </div>
    </div>

</template>

<script>   
    export default { 
    name: 'Direitos ',

    props: {
        cor: true,
        traduzir: true,
    }
}
</script>

<style src="./direitos.scss" lang="scss" scoped></style>